import React from 'react';
import { styled } from '@glitz/react';
import PreviousPurchaseViewModel from './PreviousPurchaseViewModel.type';
import Image, { Preset as ImagePreset, Ratio as ImageRatio } from 'Shared/Image/Ratio';
import * as style from 'Shared/Style';

type PropType = {
    products: PreviousPurchaseViewModel[];
    isCompact: boolean;
    label: string;
    topMargin?: number;
};

const Header = styled.span({
    display: 'block',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '100%',
    marginBottom: 16,
    textTransform: 'uppercase',
});

const BaseLine = styled.span({
    display: 'block',
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center'
});

const ProductsWrap = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px'
})

const Product = styled.div({
  display: 'inline-block',
  borderRadius: 8,
  padding: {xy: '8px' },
  width: '112px',
  backgroundColor: style.colors.monochrome.extraLightGrey,
})

const ProductImageWrap = styled.div({
  textAlign: 'center',
  borderRadius: 8,
})

const ProductName = styled(BaseLine, {
  marginTop: 8,
  marginBottom: 4,
  textTransform: 'uppercase',
  lineHeight: '100%',
})

const ProductSize = styled(BaseLine, {
  lineHeight: '120%',
})

export const PreviousPurchaseList = (props: PropType) => {
    const { products, isCompact, label, topMargin } = props;

    if(!products) {
        return <></>;
    }

    return (
        <styled.Div
            css= {topMargin ? {
                marginTop: topMargin,
            } : {}}
        >
          <Header>{label}</Header>
          <ProductsWrap>
            {products?.map((product, index) => (
              <Product key={index} >
                <ProductImageWrap>
                  <Image
                    src={{ url: product.imageUrl }}
                    title={product.displayName}
                    alt={product.displayName}
                    ratio={ImageRatio.ThreeToFour}
                    preset={ImagePreset.ItemThumbLarge}
                    breakPoint={isCompact ? 3 : 5}
                  />
                </ProductImageWrap>
                <div>
                    <ProductName>{product.displayName}
                    </ProductName>
                    <ProductSize>{product.sizeLabel}</ProductSize>
                </div>
              </Product>
            ))}
          </ProductsWrap>
        </styled.Div>
    );
};

export default PreviousPurchaseList;